import React from 'react';
import ReactDOM from 'react-dom';
import { fetchFeatures } from '@peoplenet/vi-components-ui/src/FeatureHub/FeatureHubActions';
import App from './App';
import { GEOTAB_SYSTEM_ID } from './geotab/geotabService';
import store from './store';

setTimeout(() => {
  store.dispatch(fetchFeatures(GEOTAB_SYSTEM_ID)).then(() => {
    ReactDOM.render(<App />, document.getElementById('root'));
  });
}, 0);
